import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ProdutoFormProps, ProdutoFormData } from '../../types';
import SimplePriceInput from '../Common/SimplePriceInput';

const ProdutoForm: React.FC<ProdutoFormProps> = ({ show, onHide, onSave, produto = null }) => {
  const [formData, setFormData] = useState<ProdutoFormData>({
    titulo: produto?.titulo || '',
    tamanho: produto?.tamanho || '',
    cor: produto?.cor || '',
    quantidade: produto?.quantidade || 1,
    descricao: produto?.descricao || '',
    preco: produto?.preco || 0
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  // Sincronizar formData quando a prop produto mudar
  useEffect(() => {
    if (produto) {
      setFormData({
        titulo: produto.titulo || '',
        tamanho: produto.tamanho || '',
        cor: produto.cor || '',
        quantidade: produto.quantidade || 1,
        descricao: produto.descricao || '',
        preco: produto.preco || 0
      });
    } else {
      setFormData({
        titulo: '',
        tamanho: '',
        cor: '',
        quantidade: 1,
        descricao: '',
        preco: 0
      });
    }
  }, [produto]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    
    // Campos que devem ser convertidos para maiúscula
    const textFields = ['titulo', 'tamanho', 'cor'];
    
    setFormData({
      ...formData,
      [name]: (name === 'quantidade' || name === 'preco') ? 
        (name === 'preco' ? parseFloat(value) || 0 : parseInt(value) || 0) : 
        textFields.includes(name) ? value.toUpperCase() : value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await onSave(formData);
      setFormData({
        titulo: '',
        tamanho: '',
        cor: '',
        quantidade: 1,
        descricao: '',
        preco: 0
      });
      onHide();
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="xl" 
      centered
      dialogClassName="modal-dialog-centered modal-xl"
      contentClassName="modal-content-centered"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {produto ? 'Editar Produto' : 'Novo Produto'}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          
          <Row>
            <Col md={8}>
              <Form.Group className="mb-3">
                <Form.Label>Título *</Form.Label>
                <Form.Control
                  type="text"
                  name="titulo"
                  value={formData.titulo}
                  onChange={handleChange}
                  required
                  placeholder="Ex: Terno Social Azul"
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Quantidade *</Form.Label>
                <Form.Control
                  type="number"
                  name="quantidade"
                  value={formData.quantidade}
                  onChange={handleChange}
                  required
                  min="0"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Tamanho *</Form.Label>
                <Form.Control
                  type="text"
                  name="tamanho"
                  value={formData.tamanho}
                  onChange={handleChange}
                  required
                  placeholder="Ex: 50, P, M, G, GG"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cor *</Form.Label>
                <Form.Control
                  type="text"
                  name="cor"
                  value={formData.cor}
                  onChange={handleChange}
                  required
                  placeholder="Ex: Azul marinho"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
           
            <Col md={4} className='mb-3'>
              <SimplePriceInput
                label="Preço"
                value={formData.preco || 0}
                onChange={(value: number) => setFormData({ ...formData, preco: value })}
                placeholder="R$ 0,00"
              />
              <small className="text-muted">
                Valor atual: {formData.preco || 0}
              </small>
            </Col>
          </Row>

         

          <Form.Group className="mb-3">
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="descricao"
              value={formData.descricao}
              onChange={handleChange}
              placeholder="Descrição detalhada do produto"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ProdutoForm;
